<p class="fms-notification-title" *ngIf="title">{{ title }}</p>
<p class="fms-notification-body" *ngIf="body">{{ body }}</p>
<div class="fms-notification-actions">
  <button
    *ngFor="let action of actions"
    vng-button
    size="sm"
    type="button"
    [variant]="variantFor(action)"
    (click)="choose(action)"
  >
    {{ action.label }}
  </button>
</div>
